import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Manifesto from "@/components/Manifesto";
import AboutHakan from "@/components/AboutHakan";
import Pricing from "@/components/Pricing";
import FreeTip from "@/components/FreeTip";
import Archive from "@/components/Archive";
import Testimonials from "@/components/Testimonials";
import Payments from "@/components/Payments";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WelcomeOffer from "@/components/WelcomeOffer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/stats`);
        setStats(data);
      } catch (e) {
        console.error("stats failed", e);
      }
    })();
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "").split("?")[0];
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }, []);

  return (
    <div data-testid="home-page" className="grain">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Stats stats={stats} />
        <Manifesto />
        <AboutHakan />
        <Pricing />
        <FreeTip />
        <Archive />
        <Testimonials />
        <Payments />
        <ContactSection />
      </main>
      <Footer />
      <WelcomeOffer />
    </div>
  );
};

export default HomePage;
